import * as React from 'react';
import style from './IndexPageMemberView.scss';
import { Text, WEIGHTS, SIZES } from '../../../../PageElements/Text';
import { MembersList } from './MembersList/index';
import { Text as WSRText } from 'wix-style-react';

export const MEMBER_TYPES = {
  function: 'function',
  subCategory: 'subCategory',
  tag: 'tag',
  method: 'method',
  webhooks: 'webhooks',
  clientEvents: 'clientEvents',
};

export const IndexPageMemberView = React.memo(
  ({
    memberDataHook,
    title,
    subtitle,
    members,
    prefix,
    type,
    nameRenderer,
    dataHook,
  }) => {
    return (
      !!(members && members.length) && (
        <div
          className={style.memberViewContainer}
          data-hook={dataHook || 'member-container'}
        >
          <span className={style.memberViewTitle}>
            <WSRText ellipsis weight="bold" dataHook="member-title">
              {title}
            </WSRText>
            {subtitle && (
              <Text
                size={SIZES.small}
                weight={WEIGHTS.thin}
                secondary
                className={style.memberViewSubtitle}
              >
                {subtitle}
              </Text>
            )}
          </span>
          <MembersList
            members={members}
            memberDataHook={memberDataHook}
            prefix={prefix}
            type={type}
            nameRenderer={nameRenderer}
          />
        </div>
      )
    );
  },
);
